import styled from '@emotion/styled';
import {
  Button as CommonButton,
  Icon as CommonIcon,
  Stack,
} from '@pairy/pds-react';
import { theme } from '@pairy/styles';

/* 드롭다운 앵커 + 호버 노출 기준 래퍼 */
export const PillWrapper = styled.div`
  position: relative;

  /* 가운데 비율 트리거는 기본 숨김, 호버/메뉴 열림 시 노출 */
  &:hover .zoom-percent-area,
  &.is-menu-open .zoom-percent-area {
    max-width: 120px;
    opacity: 1;
  }
`;

/* V1 ZoomButton과 동일한 pds Button 기반 알약형 컨테이너 */
export const PillButton = styled(CommonButton)`
  width: auto;
  height: 59px;
  transition: opacity 0.15s ease-in-out, width 0.15s ease-in-out;

  &.disable {
    cursor: initial;
    opacity: 0.25;
  }
`;

/* V1과 동일한 아이콘 여백 */
export const PillIcon = styled(CommonIcon)`
  margin: 4px;
  cursor: pointer;
`;

export const PercentArea = styled.div`
  display: flex;
  overflow: hidden;
  max-width: 0;
  align-items: center;
  opacity: 0;
  transition: max-width 0.15s ease-in-out, opacity 0.15s ease-in-out;
`;

export const PercentTrigger = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  white-space: nowrap;
`;

export const Dropdown = styled(Stack)`
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  min-width: 148px;
  padding: 4px;
  border: 1px solid ${theme.colors.zinc_200};
  background: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: ${theme.elevation.md};
  transform: translateX(-50%);
`;

export const MenuDivider = styled.div`
  height: 1px;
  margin: 4px 0;
  background: ${theme.colors.zinc_200};
`;

export const PresetItem = styled.button<{ isActive: boolean }>`
  padding: 6px 12px;
  border: none;
  background: ${({ isActive }) =>
    isActive ? theme.colors.skyblue_50 : theme.colors.white};
  border-radius: 6px;
  color: ${({ isActive }) =>
    isActive ? theme.colors.skyblue_500 : theme.colors.zinc_700};
  cursor: pointer;
  font-size: ${theme.fontSize.md};
  text-align: center;
  transition: 0.15s ease-in-out;

  &:hover {
    background: ${theme.colors.zinc_100};
  }
`;

/* 가로 맞춤/페이지 맞춤/전체화면 등 액션 메뉴 아이템 */
export const ActionItem = styled.button<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border: none;
  background: ${({ isActive }) =>
    isActive ? theme.colors.skyblue_50 : theme.colors.white};
  border-radius: 6px;
  color: ${({ isActive }) =>
    isActive ? theme.colors.skyblue_500 : theme.colors.zinc_700};
  cursor: pointer;
  font-size: ${theme.fontSize.md};
  gap: 8px;
  transition: 0.15s ease-in-out;
  white-space: nowrap;

  &:hover {
    background: ${theme.colors.zinc_100};
  }
`;
